import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const OrgIntegrationActionsCell = (props: {
  description: string;
  onUnlink: () => void;
}) => {
  const [isUnlinkOpen, toggleUnlinkOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Unlink', onSelect: toggleUnlinkOpen }]}
        trigger={
          <IconButton data-testid={`actions-${camelCase(props.description)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Unlink'
        data-testid={camelCase(`unlink ${props.description}`)}
        isOpen={isUnlinkOpen}
        message={`Unlink ${props.description} from this advisory organization?`}
        onCancel={toggleUnlinkOpen}
        onConfirm={() => {
          toggleUnlinkOpen();
          props.onUnlink();
        }}
        title='Unlink Integration'
      />
    </>
  );
};
